import React, { useEffect, useRef } from 'react';
import history from '@AppRoutes/history';
import { useLocation } from 'react-router-dom';
import { paths } from '@AppRoutes/constants';
import { TabGroup, TabPanel } from '@els/els-react--tab-group';

import './ProfileSettingsHeader.scss';

const PROFILE_SETTING_ROUTES = [
  {
    name: 'Account',
    pathName: paths.PROFILE_ACCOUNT,
  },
  {
    name: 'Profile',
    pathName: paths.PROFILE_PROFILE,
  },
  {
    name: 'Preferences',
    pathName: paths.PROFILE_PREFERENCES,
  },
];

function ProfileSettingsHeader() {
  const location = useLocation();
  const tabGroupRef = useRef();

  useEffect(() => {
    const activeTabIndex = PROFILE_SETTING_ROUTES.findIndex((route) => route.pathName === location.pathname);
    if (activeTabIndex !== -1) {
      tabGroupRef.current?.setActiveTab(activeTabIndex);
    }
  }, [location.pathname]);

  // FR-3.3: the "Profile" title and the Account/Profile/Preferences tab group are rendered as
  // SEPARATE sibling blocks (a fragment) rather than one wrapper, so the sticky tab block's
  // containing block is the tall parent `.profile-setting` (which spans header + page content)
  // instead of a short header-height box — otherwise `position: sticky` would un-pin the moment
  // that short box scrolled past. The title block scrolls away; only the tab block sticks
  // (ProfileSettingsHeader.scss, desktop-gated).
  return (
    <>
      <div className="profile-setting-header profile-setting-header--title">
        <div className="profile-setting-header__content">
          <h1 id="profile-title" className="profile-setting-header__content_title">
            Profile
          </h1>
        </div>
      </div>
      <div className="profile-setting-header profile-setting-header--tabs">
        <div className="profile-setting-header__content">
          <TabGroup
            ref={tabGroupRef}
            id="profile-settings-tabs"
            className="profile-setting-header__content_tabs"
            hasDivider
            isControlled
            label="Profile menu"
            tabs={PROFILE_SETTING_ROUTES.map((route) => (
              <span key={route.name} data-e2e={`profile-settings-nav-${route.name}`}>
                {route.name}
              </span>
            ))}
            onTabChange={(tabIndex) => {
              const route = PROFILE_SETTING_ROUTES[Number(tabIndex)];
              if (route?.pathName && route.pathName !== location.pathname) {
                history.push(route.pathName);
              }
            }}>
            {PROFILE_SETTING_ROUTES.map((route) => (
              <TabPanel key={route.name}>
                <span className="u-els-hide-visually">{route.name}</span>
              </TabPanel>
            ))}
          </TabGroup>
        </div>
      </div>
    </>
  );
}

export default ProfileSettingsHeader;
